/**
 * KAN-988: коды функций кабинета, те же, что у backend (features в /auth/me).
 * KAN-1000: тарифов нет, все зарегистрированные функции открыты любому кабинету;
 * решает это одно место, useFeature. Подписи функций только отсюда.
 */
export type FeatureCode = 'crm' | 'bot_learning' | 'manager_alerts' | 'manager_app';

export const FEATURE_LABELS: Record<FeatureCode, string> = {
  crm: 'CRM',
  bot_learning: 'Обучение ботов',
  manager_alerts: 'Сигнализация неразобранных',
  manager_app: 'Приложение менеджера',
};

/** Код из словаря функций платформы. */
export function isFeatureCode(code: string): code is FeatureCode {
  return Object.prototype.hasOwnProperty.call(FEATURE_LABELS, code);
}

/**
 * Включена ли функция: зарегистрированная всегда (тарифов нет), неизвестный
 * код только если backend прислал его в features. Единственное правило
 * доступности для useFeature и меню. То же правило на backend: billing/features.py org_features.
 */
export function isFeatureEnabled(code: string, features: readonly string[]): boolean {
  return isFeatureCode(code) || features.includes(code);
}

/** Подпись функции; неизвестный код показывается как есть. */
export function featureLabel(code: string): string {
  return isFeatureCode(code) ? FEATURE_LABELS[code] : code;
}
